import { Component, Input } from '@angular/core';
import { ConfigService } from '@core/services/config.service';

@Component({
  selector: 'mfp-amount-currency',
  templateUrl: './amount-currency.component.html',
  styleUrls: ['./amount-currency.component.scss']
})
export class AmountCurrencyComponent {
  currencyPosition: 'left' | 'right' = 'right';

  constructor(private configService: ConfigService) {
    this.currencyPosition = this.configService.config?.currencyPosition;
  }
}
